import { investorState } from '../types/propsTypes'
import { resolveRiskProfilerRequired } from './onboarding'

export const setInvestorDataToSS = (investorData: investorState) => {
  sessionStorage.setItem('authToken', investorData.authToken)
  sessionStorage.setItem(
    'investor_data',
    JSON.stringify({
      name: investorData.name,
      email: investorData.email,
      userId: investorData.userId,
      role: investorData.role,
      isEmailVerified: investorData.isEmailVerified,
      acceptedNDA: investorData.acceptedNDA,
      kycStatus: investorData.kycStatus,
      rememberMe: investorData.rememberMe,
      isActiveSession: investorData.isActiveSession,
      accountStatus: investorData.accountStatus,
      adminEmail: investorData.adminEmail,
      adminRole: investorData.adminRole,
      phone: investorData.phone,
      investorReference: investorData.investorReference ?? '',
      basicDetailsCompleted: investorData.basicDetailsCompleted ?? false,
      riskProfileCompleted: investorData.riskProfileCompleted ?? false,
      riskProfilerRequired: resolveRiskProfilerRequired(investorData),
      onboardingDeferred: investorData.onboardingDeferred ?? false,
    }),
  )
}

export const removeInvestorDataFromLS = () => {
  localStorage.removeItem('authToken')
  localStorage.removeItem('investor_data')
  localStorage.clear()
}

export const removeInvestorDataFromSS = () => {
  sessionStorage.removeItem('authToken')
  sessionStorage.removeItem('investor_data')
  sessionStorage.clear()
}

export const getInvestorDataFromSS = () => {
  const investorData = sessionStorage.getItem('investor_data')
  const authToken = sessionStorage.getItem('authToken')
  return {
    investorData: investorData ? JSON.parse(investorData) : null,
    authToken,
  }
}
